module.exports = __webpack_public_path__ + "static/media/knet-seal-logo.4d68224a.png";